import React, { useEffect, useRef } from 'react';

export default function CustomCursor() {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });
  const outerPos = useRef({ x: 0, y: 0 });
  const raf = useRef(null);

  useEffect(() => {
    const onMove = (e) => {
      pos.current = { x: e.clientX, y: e.clientY };
      if (innerRef.current) {
        innerRef.current.style.left = `${e.clientX}px`;
        innerRef.current.style.top = `${e.clientY}px`;
      }
    };

    const animate = () => {
      outerPos.current.x += (pos.current.x - outerPos.current.x) * 0.12;
      outerPos.current.y += (pos.current.y - outerPos.current.y) * 0.12;
      if (outerRef.current) {
        outerRef.current.style.left = `${outerPos.current.x}px`;
        outerRef.current.style.top = `${outerPos.current.y}px`;
      }
      raf.current = requestAnimationFrame(animate);
    };

    const onEnterLink = () => {
      if (outerRef.current) {
        outerRef.current.style.transform = 'translate(-50%, -50%) scale(1.6)';
        outerRef.current.style.borderColor = 'rgba(59,130,246,0.9)';
        outerRef.current.style.background = 'rgba(59,130,246,0.05)';
      }
    };

    const onLeaveLink = () => {
      if (outerRef.current) {
        outerRef.current.style.transform = 'translate(-50%, -50%) scale(1)';
        outerRef.current.style.borderColor = 'rgba(59,130,246,0.6)';
        outerRef.current.style.background = 'transparent';
      }
    };

    document.addEventListener('mousemove', onMove);
    document.querySelectorAll('a, button, [role="button"]').forEach((el) => {
      el.addEventListener('mouseenter', onEnterLink);
      el.addEventListener('mouseleave', onLeaveLink);
    });

    raf.current = requestAnimationFrame(animate);

    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <>
      <div ref={outerRef} className="cursor-outer" />
      <div ref={innerRef} className="cursor-inner" />
    </>
  );
}
